import Layout from "@/layout/Layout.vue";
import { P } from "@/config/permissions";

const telephonyRoutes = {
    path: "/telephony",
    name: "telephony",
    component: Layout,
    redirect: "/telephony/peers",
    alwaysShow: true,
    meta: {
        title: "Téléphonie",
        icon: "mdi:phone-check",
        permissions: [P.TELEPHONY.VIEW_PEERS],
        noCache: true
    },
    children: [
        {
            path: "peers",
            name: "telephony-peers",
            meta: {
                title: "Postes SIP",
                icon: "mdi:phone-classic",
                noCache: true,
                permissions: [P.TELEPHONY.VIEW_PEERS]
            },
            component: () => import("@/views/telephony/PeersList.vue")
        },
        {
            path: "peers/:id(\\d+)",
            name: "telephony-peer-show",
            meta: {
                title: "Détail poste",
                noCache: true,
                permissions: [P.TELEPHONY.VIEW_PEERS]
            },
            component: () => import("@/views/telephony/PeerDetail.vue"),
            hidden: true
        },
        {
            path: "channels",
            name: "telephony-channels",
            meta: {
                title: "Appels en cours",
                icon: "mdi:phone-in-talk",
                noCache: true,
                permissions: [P.TELEPHONY.VIEW_CHANNELS]
            },
            component: () => import("@/views/telephony/ChannelsList.vue")
        }
    ]
};

export default telephonyRoutes;
